const bundleReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_QUANTITY':
      return updateStateQuantity(state, action);
    case 'ADD_BUNDLE_TO_CART':
      return {
        ...state,
        isLoading: true,
      };
    case 'ADD_BUNDLE_TO_CART_SUCCESS':
      // this open the cart popup
      update_theme_cart();
      return {
        ...state,
        bundleInCart: true,
        isLoading: false,
      };
    default:
      throw new Error(`Error in Bundle Reducer: Unkown action ${action.type}`);
  }
};

/**
 * update the state quantity of one item
 *
 * @param {*} state the reducer state
 * @param {*} action the action
 */
const updateStateQuantity = (state, action) => {
  const { id, quantity } = action.payload;
  const itemIdx = state.items.findIndex((item) => item.variant.id == id);
  const alteredItems = state.items;
  alteredItems[itemIdx].quantity = quantity;
  const newState = {
    ...state,
    items: alteredItems,
  };
  return newState;
};

export default bundleReducer;
